import React, { useState } from 'react'
import Sidebar from '../dashboard/Sidebar'
import Navbar from '../dashboard/Navbar'
import { Outlet } from 'react-router-dom'
import { usePolling } from '../../services/PollingContext'


const Home = () => {
  const { notifications, markNotificationAsRead, dismissNotification, markAllAsRead, getUnreadCount } = usePolling();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="bg-[#0D0D0E] h-screen overflow-hidden flex flex-row">
      <Sidebar
        mobileOpen={mobileOpen}
        onCloseMobileSidebar={() => setMobileOpen(false)}
      />
      <div className="flex flex-col flex-1 min-w-0">
        <Navbar
          notifications={notifications}
          markNotificationAsRead={markNotificationAsRead}
          dismissNotification={dismissNotification}
          markAllAsRead={markAllAsRead}
          getUnreadCount={getUnreadCount}
          onOpenMobileSidebar={() => setMobileOpen(true)}
        />
        <div className="flex-1 overflow-y-auto overflow-x-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default Home
